import styled from 'styled-components';
import { createGradientOrSolid } from 'utils/index';
import { breakpoints } from 'styles/breakpoints';
import { Gradient } from 'utils/types';

interface IStyledHeaderV2Props {
  profileFrameImg?: string;
  backgroundOpacity?: number;
  profilePicBorder?: Gradient;
  opacityPercentage?: number;
  playerFontSize?: number;
  playerWeight?: number;
  playerTransform?: string;
  isSticky?: boolean;
}

export const StyledHeaderV2 = styled.header<IStyledHeaderV2Props>`
  width: 100%;
  min-height: 40px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  position: ${({ isSticky }) => (isSticky ? 'sticky' : 'relative')};
  top: 0;
  z-index: 10;
  backdrop-filter: ${({ backgroundOpacity, isSticky }) =>
    backgroundOpacity && isSticky ? 'blur(10px)' : 'none'};

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    min-height: 40px;
    background: #000;
    opacity: ${({ backgroundOpacity }) => `${backgroundOpacity}%`};
    z-index: -1;
  }

  .container {
    width: 100%;
    max-width: 1240px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    box-sizing: border-box;

    &-user {
      display: flex;
      align-items: center;

      &--pic {
        width: 40px;
        height: 40px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        background: ${({ profilePicBorder, profileFrameImg }) =>
          profilePicBorder && !profileFrameImg
            ? createGradientOrSolid(profilePicBorder)
            : 'none'};
        border-radius: 50%;
        padding: 1px;

        &:after {
          display: ${({ profileFrameImg }) =>
            profileFrameImg ? 'block' : 'none'};
          content: '';
          position: absolute;
          width: 40px;
          height: 40px;
          background: ${({ profileFrameImg }) =>
            profileFrameImg
              ? `url(${profileFrameImg}) no-repeat center/contain`
              : 'none'};
          background-size: 100% 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .user-pic {
          box-sizing: border-box;
          border-radius: 50%;
          object-fit: contain;
          width: 100%;
          height: 100%;
          min-height: 38px;
          min-width: 38px;
        }
      }

      &--info {
        margin-left: 8px;

        .user {
          &-name {
            color: #fff;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }

          &-balances {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
          }
        }
      }
    }

    &-logo {
      width: auto;
      height: 60px;

      &--img {
        width: auto;
        height: 60px;
        max-width: 100px;
        object-fit: contain;
      }
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    .container {
      padding-bottom: 12px;
      padding-top: 12px;

      &-user {
        &--pic {
          width: 56px;
          height: 56px;

          &:after {
            width: 56px;
            height: 56px;
          }
        }

        &--info {
          .user-name {
            font-size: ${({ playerFontSize }) => `${playerFontSize}px`};
          }
        }
      }

      &-logo {
        height: 56px;
        &--img {
          height: 56px;
        }
      }
    }
  }
`;
